var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCheckOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54545 0C2.03507 0 0 2.03507 0 4.54545V15.4545C0 17.9649 2.03507 20 4.54545 20H15.4545C17.9649 20 20 17.9649 20 15.4545V4.54545C20 2.03507 17.9649 0 15.4545 0H4.54545ZM6.99999 14.7666C7.43332 15.1999 8.13332 15.1999 8.56666 14.7666L16.9889 6.33325C17.4222 5.89992 17.4222 5.19992 16.9889 4.76658C16.5555 4.33325 15.8555 4.33325 15.4222 4.76658L7.77777 12.411L4.57777 9.21103C4.14443 8.77769 3.44444 8.77769 3.0111 9.21103C2.57777 9.64436 2.57777 10.3444 3.0111 10.7777L6.99999 14.7666Z",
    fill: "#426AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckOn);
export default __webpack_public_path__ + "static/media/ic-check-on.61bf77e0a3a5728f6b5a53f96e5fe466.svg";
export { ForwardRef as ReactComponent };